module.exports = __webpack_public_path__ + "assets/img/two-tab8-on.4e58682d.png";